export default class CountryItem {
  constructor(item) {
    if (item === undefined) {
      this.CountryId = '';
      this.Name = '';
      this.Code = '';
    } else {
      this.CountryId = item.countryId;
      this.Name = item.name;
      this.Code = item.code;
    }
    this.SelectedInList = false;
  }

  static displayedInList = 'Name';
}
